/* Progressive enhancement: every colour and its destination remain usable without JavaScript. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('ih-colour-palette')) return;
  customElements.define('ih-colour-palette', class extends HTMLElement {
    connectedCallback() {
      this._initFrame = requestAnimationFrame(() => this.initialise());
    }
    initialise() {
      if (this._active || !this.isConnected) return;
      this._active = true;
      this._cards = Array.from(this.querySelectorAll('[data-colour-card]'));
      this._buttons = Array.from(this.querySelectorAll('[data-colour-filter]'));
      this._click = (event) => {
        const button = event.target.closest('[data-colour-filter]');
        if (button && this.contains(button)) this.applyFilter(button.dataset.colourFilter);
      };
      this._hash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
        const card = this._cards.find(item => item.id === id);
        if (card && card.hidden) {
          this.applyFilter('all');
          card.scrollIntoView({behavior:'auto', block:'start'});
        }
      };
      this._blockSelect = (event) => {
        if (event.detail && this._cards.some(card => card.dataset.blockId === event.detail.blockId)) this.applyFilter('all');
      };
      this.addEventListener('click', this._click);
      window.addEventListener('hashchange', this._hash);
      if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:block:select', this._blockSelect);
      const tools = this.querySelector('[data-colour-tools]');
      if (tools && this._cards.length) tools.hidden = false;
      this._hash();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._initFrame);
      this.removeEventListener('click', this._click);
      window.removeEventListener('hashchange', this._hash);
      document.removeEventListener('shopify:block:select', this._blockSelect);
      this._active = false;
    }
    applyFilter(group) {
      if (!this._buttons.some(button => button.dataset.colourFilter === group)) return;
      let count = 0;
      this._cards.forEach(card => {
        const groups = (card.dataset.colourGroups || '').trim().split(/\s+/);
        card.hidden = group !== 'all' && !groups.includes(group);
        if (!card.hidden) count++;
      });
      this._buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colourFilter === group)));
      const counter = this.querySelector('[data-colour-count]');
      if (counter) counter.textContent = String(count);
      const empty = this.querySelector('[data-colour-empty]');
      if (empty) empty.hidden = count > 0;
    }
  });
})();
